/**
 * Копирует текст в буфер обмена. Основной путь — Clipboard API, но он доступен
 * только в защищённом контексте и может быть запрещён permissions policy
 * (в частности, внутри iframe), поэтому есть фолбэк на скрытую textarea.
 * Возвращает признак успеха, чтобы вызывающий код мог показать уведомление.
 */
export async function copyTextToClipboard(text: string): Promise<boolean> {
    if (!text) {
        return false;
    }

    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (e) {
        // Clipboard API недоступен — уходим ниже.
    }

    const textArea = document.createElement('textarea');

    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);

    textArea.focus();
    textArea.select();

    let copied = false;

    try {
        copied = document.execCommand('copy');
    } catch (e) {
        console.error('Не удалось скопировать текст: ', e);
    }

    document.body.removeChild(textArea);

    return copied;
}
